/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_LoadingInputs */

const en_us2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the conversation`)
};

const pt_br2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando a conversa`)
};

const es_419_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando la conversación`)
};

const pt_pt2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar a conversa`)
};

const fr_fr2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la conversation`)
};

const de_de2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung wird geladen`)
};

const it_it2_coach_loading = /** @type {(inputs: Coach_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento della conversazione`)
};

/**
* | output |
* | --- |
* | "Loading the conversation" |
*
* @param {Coach_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_loading = /** @type {((inputs?: Coach_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_loading(inputs)
	if (locale === "es-419") return es_419_coach_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_loading(inputs)
	if (locale === "de-DE") return de_de2_coach_loading(inputs)
	if (locale === "it-IT") return it_it2_coach_loading(inputs)
	return en_us2_coach_loading(inputs)
});
export { coach_loading as "coach.loading" }